import { request } from '@/utils/http'

/**
 * 上传整箱运价 Excel（异步任务，返回 taskId）
 */
export const uploadFclExcel = (file: File) => {
  const formData = new FormData()
  formData.append('file', file)
  return request.post<string>('/mq/fcl/excel/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/**
 * 确认导入整箱运价（上架本批次草稿）
 */
export const confirmFclImport = (batchNo: string, taskId: string) =>
  request.post<boolean>('/mq/fcl/excel/confirm', null, {
    params: { batchNo, taskId }
  })

/**
 * 取消导入整箱运价（删除本批次草稿）
 */
export const cancelFclImport = (batchNo: string, taskId: string) =>
  request.post<boolean>('/mq/fcl/excel/cancel', null, {
    params: { batchNo, taskId }
  })
